import { Component, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';

@Component({
    selector: 'app-terms-of-services',
    templateUrl: './terms-of-services.component.html',
    styleUrls: ['./terms-of-services.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class TermsOfServicesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
